<template>
    <v-card flat tile class="gallery-card" v-bind="{ to, disabled }">
        <div class="gallery-card__img-wrap">
            <v-img :aspect-ratio="585 / 240" :src="program?.thumb?.url" class="grey-ef" />
        </div>
        <div class="gallery-card__con py-20 pt-lg-20 pb-lg-30 px-lg-40">
            <div class="mb-10 mb-md-14">
                <h4 class="tit tit--sm font-notoserif primary--text ellip">{{ program?.subject }}</h4>
            </div>
            <div class="font-size-14 font-size-md-16">
                <v-row no-gutters align="baseline">
                    <v-col cols="auto">
                        <span>일시</span>
                    </v-col>
                    <v-col cols="auto">
                        <div class="grey-68--text pl-12">{{ at }}</div>
                    </v-col>
                </v-row>
                <v-row no-gutters align="baseline" class="mt-2 mt-md-4">
                    <v-col cols="auto">
                        <span>기간</span>
                    </v-col>
                    <v-col cols="auto">
                        <div class="grey-68--text pl-12">{{ duration }}</div>
                    </v-col>
                </v-row>
                <v-row no-gutters align="baseline" class="mt-2 mt-md-4">
                    <v-col cols="auto">
                        <span>장소</span>
                    </v-col>
                    <v-col cols="auto">
                        <div class="grey-68--text pl-12">{{ program?.location }}</div>
                    </v-col>
                </v-row>
            </div>
        </div>
        <v-divider class="primary"></v-divider>
    </v-card>
</template>

<script>
import dayjs from "dayjs";

const days_ko = ["일", "월", "화", "수", "목", "금", "토"];

export default {
    props: ["program"],
    computed: {
        disabled() {
            return !this.$dayjs().isAfter(this.program.duration.startsAt);
        },
        to() {
            let path = null;
            if (!this.disabled) path = `/auction-programs/${this.program?._id}`;
            return path;
        },
        at() {
            let { at } = this.program || {};
            if (at) {
                at = dayjs(at);
                const date = at.format("YYYY년 M월 D일");
                const day = days_ko[at.day()];
                const ampm = at.hour() >= 12 ? "PM" : "AM";
                const time = at.format("hh:mm");

                return `${date} (${day}) ${ampm} ${time} KST`;
            }

            return null;
        },
        duration() {
            let { duration: { startsAt, endsAt } = {} } = this.program || {};
            if (startsAt && endsAt) {
                startsAt = dayjs(startsAt);
                endsAt = dayjs(endsAt);
                const day_startsAt = days_ko[startsAt.day()];
                const day_endsAt = days_ko[endsAt.day()];

                const isSameYear = startsAt.year() == endsAt.year();
                if (isSameYear) endsAt = endsAt.format("M월 D일");
                else endsAt = endsAt.format("YYYY년 M월 D일");
                startsAt = startsAt.format("YYYY년 M월 D일");

                return `${startsAt} (${day_startsAt}) ~ ${endsAt} (${day_endsAt})`;
            }

            return null;
        },
    },
};
</script>

<style></style>
